import { bl_pos_sales_lead_label_hdr_RowClass } from '../../../dbschema/bl_pos_sales_lead_label_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class PosSalesLeadLabelContainerModel extends BaseContainerModel {
  bl_pos_sales_lead_label_hdr: bl_pos_sales_lead_label_hdr_RowClass = new bl_pos_sales_lead_label_hdr_RowClass();
}
